let env = {...process.env} as Record<string, string>;

if (window.location.hostname.endsWith('marketingsites-prod.microsoft.com')) {
    env.REACT_APP_API_URL = 'https://appeals.euap.contentvalidation.com';
} else if (window.location.hostname.endsWith('microsoft.com')) {
    env.REACT_APP_API_URL = 'https://appeals.contentvalidation.com';
} else if (window.location.hostname === 'localhost') {
    env.REACT_APP_API_URL = env.REACT_APP_API_URL ?? window.location.origin;
} else {
    env.REACT_APP_API_URL = window.location.origin;
}

// Backend origin for popup CAPTCHA (direct to contentvalidation.com, cross-origin).
// Popup is a top-level window, so SameSite=Strict cookies work.
env.REACT_APP_BACKEND_URL = window.location.hostname === 'localhost'
    ? 'https://localhost:44372'
    : env.REACT_APP_API_URL;

export default env;